import React from 'react';
import { Link } from 'react-router-dom';
import { 
  BsCodeSlash, 
  BsRobot, 
  BsGraphUpArrow, 
  BsBoxSeam, 
  BsPalette, 
  BsGear,
  BsArrowRight 
} from 'react-icons/bs';

const servicesList = [
  {
    icon: <BsCodeSlash className="text-2xl" />,
    title: "Web Development",
    desc: "Modern, fast and scalable websites that convert.",
    link: "/services"
  },
  {
    icon: <BsRobot className="text-2xl" />,
    title: "AI Solutions",
    desc: "Custom AI tools, automation and intelligent systems for your business.",
    link: "/ai-automation"
  },
  {
    icon: <BsGraphUpArrow className="text-2xl" />,
    title: "Digital Marketing",
    desc: "Strategies that get you more traffic, leads and revenue.",
    link: "/digital-marketing"
  },
  {
    icon: <BsBoxSeam className="text-2xl" />,
    title: "Web Applications",
    desc: "Powerful web apps tailored to your goals.",
    link: "/software-development"
  },
  {
    icon: <BsPalette className="text-2xl" />,
    title: "UI/UX Design",
    desc: "Beautiful and user-friendly designs that create experiences.",
    link: "/ui-ux-design"
  },
  {
    icon: <BsGear className="text-2xl" />,
    title: "Maintenance & Support",
    desc: "Keep your digital assets secure, fast and updated.",
    link: "/services"
  }
];

const WhatWeBuild = () => {
  return (
    <section className="py-16 sm:py-24 bg-white text-slate-900 border-b border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-14 items-center">
          
          {/* Left Column: Heading, Description & Explore Button */}
          <div className="lg:col-span-5 space-y-6" data-aos="fade-right">
            
            {/* Tag */}
            <div className="flex items-center gap-2">
              <span className="w-2 h-2 rounded-sm bg-[#f06600]"></span>
              <span className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">
                WHAT WE DO
              </span>
            </div>

            {/* Title */}
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-slate-900 tracking-tight leading-[1.15]">
              Full-Service Digital<br />
              Partner for <span className="text-[#f06600]">Growing<br />Businesses</span>
            </h2>

            {/* Description */}
            <p className="text-slate-600 text-sm sm:text-base leading-relaxed max-w-md">
              From stunning websites to AI-powered solutions and result-driven marketing — we provide everything you need to succeed in the digital world.
            </p>

            {/* Button */}
            <div className="pt-2">
              <Link
                to="/services"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-slate-300 hover:border-[#f06600] text-slate-800 hover:text-[#f06600] font-semibold text-xs tracking-wide transition-all shadow-sm hover:shadow group"
              >
                <span>Explore All Services</span>
                <BsArrowRight className="text-sm group-hover:translate-x-1 transition-transform" />
              </Link>
            </div>

          </div>

          {/* Right Column: 6 Service Cards in 2 Columns */}
          <div className="lg:col-span-7" data-aos="fade-left">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-5">
              {servicesList.map((service, idx) => (
                <Link
                  key={idx}
                  to={service.link}
                  className="bg-[#fcfdfd] hover:bg-white border border-slate-100 hover:border-orange-200 rounded-2xl p-6 sm:p-7 text-center flex flex-col items-center justify-center shadow-sm hover:shadow-xl hover:shadow-orange-500/5 transition-all duration-300 transform hover:-translate-y-1 group"
                >
                  <div className="w-12 h-12 rounded-xl bg-orange-50 border border-orange-100 flex items-center justify-center mb-4 text-[#f06600] group-hover:scale-110 group-hover:bg-orange-100/90 group-hover:border-orange-300 transition-all duration-300">
                    <span className="text-2xl text-[#f06600]">
                      {service.icon}
                    </span>
                  </div>
                  <h3 className="font-bold text-slate-900 group-hover:text-[#f06600] text-sm sm:text-base transition-colors">
                    {service.title}
                  </h3>
                  <p className="text-xs text-slate-500 leading-relaxed mt-2 font-normal">
                    {service.desc}
                  </p>
                </Link>
              ))}
            </div>
          </div>

        </div>

      </div>
    </section>
  );
};

export default WhatWeBuild;
